@if (collection(); as coll) {
  <div class="p-3 container-fluid">
    <div class="row">
      <div class="md:col-8 col-12">
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ getLabel(coll) }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div>
              Připojení do kolekce proběhlo úspěšně
            </div>
          </mat-card-content>
          <mat-card-actions>
            <button (click)="onRouteToCollection(coll)" mat-button>
              Přejít do kolekce
            </button>
          </mat-card-actions>
        </mat-card>
      </div>
      <div class="md:mt-0 md:col-4 col-12 mt-3">
        <mat-card>
          <mat-list>
            <div mat-subheader>Vlastník</div>
            @for (user of coll.relations['owns']; track user) {
              <mat-list-item>
                @if (user.avatar) {
                  <img [alt]="user.userId" [src]="user.avatar" matListItemAvatar/>
                }
                <div matListItemTitle>{{ user.name || user.userId }}</div>
              </mat-list-item>
            }
            @if (coll.relations['contributes'] && coll.relations['contributes'].length > 0) {
              <div mat-subheader>Spolupracovníci</div>
              @for (user of coll.relations['contributes']; track user) {
                <mat-list-item>
                  @if (user.avatar) {
                    <img [alt]="user.userId" [src]="user.avatar" matListItemAvatar/>
                  }
                  <div matListItemTitle>{{ user.name || user.userId }}</div>
                </mat-list-item>
              }
            }
          </mat-list>
        </mat-card>
      </div>
    </div>
  </div>
}
